import React from 'react';

export interface LocationCellProps {
    location: string;
}

const LocationCell: React.FC<LocationCellProps> = ({ location }) => {
    if (typeof location === 'string') {
        return <>{location}</>;
    }
    return null;
};

export default React.memo(LocationCell);
